import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-3 p-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "flex justify-end space-x-2" }

import { computed, reactive, ref } from 'vue';

import { RepairTypeResource } from '@shared/resources/repair-type';
import { RepairTypeCreateUpdateDto } from '@shared/dto/repair-type';
import { repairTypeCreateUpdateSchema } from '@shared/validation/repair-type';

import { useValidator, ValidationKeyObserver } from '@/libs/validator';
import { useRepairTypesStore } from '@/stores/dictionary/repair-types';
import { BaseModal, useModalControls } from '@/components/modals';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import Label from '@ui-kit/label/Label.vue';

interface Emits {
  (e: 'save', value: RepairTypeResource): void;
}
interface Props {
  data?: RepairTypeResource,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalManageRepairType',
  props: {
    data: null
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'save', value: RepairTypeResource): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data?: RepairTypeResource,
}





const repairTypesStore = useRepairTypesStore();
const { close } = useModalControls();

const formData = ref<RepairTypeCreateUpdateDto>({
  name: props.data?.name || '',
});

const validator = useValidator({
  data: formData,
  schema: computed(() => repairTypeCreateUpdateSchema),
});

function save() {
  if (validator.validate()) {
    let promise: Promise<RepairTypeResource>;
    if (!props.data?.id) {
      promise = repairTypesStore.add(formData.value, validator);
    } else {
      promise = repairTypesStore.update(props.data.id, formData.value, validator);
    }
    promise.then((resource) => {
      emit('save', resource);
      close();
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), {
    title: __props.data?.id ? _ctx.$t('pages.repair-types.edit-label') : _ctx.$t('pages.repair-types.create-label'),
    "no-body-padding": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ValidationKeyObserver), { keys: "name" }, {
          default: _withCtx(({ firstErrorMessage }) => [
            _createVNode(Label, {
              label: _ctx.$t('fields.name'),
              required: ""
            }, {
              default: _withCtx(({ id }) => [
                _createVNode(SingleLine, {
                  id: id,
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  errors: firstErrorMessage
                }, null, 8, ["id", "modelValue", "errors"])
              ]),
              _: 2
            }, 1032, ["label"])
          ]),
          _: 1
        }),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Button, {
            onClick: _unref(close),
            "button-type": "outline",
            disabled: _unref(repairTypesStore).isLoad
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(Button, {
            onClick: save,
            loading: _unref(repairTypesStore).isLoad
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})